import React from "react";
//#region types
import { WintSuperkollAPIModel as ApiModel, WintUtilsWebApi } from "wint-api-client/dist/types";
import { CustomerGenericProps } from "models/propTypes/customerPropTypes";
import { TodoConstants } from "utils/constants";
import { StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import {
  EntityNavigationCard,
  EntityNavigationCardContainer,
  EntityNavigationCardContent,
  Skeletons,
} from "components/common";
import { AllCompleteSimpleTodoCard } from "components/todos/simpleTodoCards";
import { useCustomerService } from "serviceHooks";
//#endregion
import { DateHelper, LocalizationHelperInstance } from "utils/helpers";

const CustomerSimpleTodoCard: React.FC<CustomerGenericProps> = (props) => {
  const customerService = useCustomerService();
  const getTodos = React.useCallback(
    async (filter?: WintUtilsWebApi.Filter) => customerService.getTodos(props.customerId ?? 0, filter),
    [props.customerId]
  );

  const render = (
    total: number,
    numPerPage: number,
    onCurrentIndexUpdate: (index: number, pageNumber: number) => void,
    markAsDone: (id: number) => void,
    invoice: ApiModel.Invoice,
    loading: boolean
  ) => {
    const diff = invoice ? DateHelper.getDiffDays(new Date(), invoice.dueDate) : undefined;
    return loading ? (
      <Skeletons.WidgetSkeleton />
    ) : (
      <EntityNavigationCard
        headerText={
          total ? LocalizationHelperInstance.getFormattedMessage(`Common.TodoType_${ApiModel.TodoType.Invoice}`) : ""
        }
        total={total}
        numPerPage={numPerPage}
        onCurrentIndexUpdate={onCurrentIndexUpdate}
        navigationText={""}
        displayType={total ? StyleEnums.DisplayType.Info : StyleEnums.DisplayType.Success}
      >
        {total ? (
          invoice !== undefined ? (
            <EntityNavigationCardContent
              title={invoice?.customerName ?? ""}
              subtitle={LocalizationHelperInstance.getFormattedCurrency(invoice?.totalAmount ?? 0, invoice?.currency)}
              footerText={
                diff && diff < 0
                  ? LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.DueDateFormatter, "", {
                      date: LocalizationHelperInstance.getFormattedDate(
                        invoice && invoice.dueDate ? invoice.dueDate.toString() : ""
                      ),
                    })
                  : LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.CreatedDateFormatter, "", {
                      date: LocalizationHelperInstance.getFormattedDate(
                        invoice && invoice.postingDate ? invoice.postingDate.toString() : ""
                      ),
                    })
              }
              showButton={false}
              displayType={StyleEnums.DisplayType.Info}
            />
          ) : (
            <></>
          )
        ) : (
          <AllCompleteSimpleTodoCard />
        )}
      </EntityNavigationCard>
    );
  };

  return (
    <EntityNavigationCardContainer
      render={render}
      filter={getTodos}
      numPerPage={TodoConstants.TodosPerPage}
    ></EntityNavigationCardContainer>
  );
};
export default CustomerSimpleTodoCard;
